
import React, { Component } from "react";
import { connect } from 'react-redux';
import { translate } from "react-i18next";
import { Field, reduxForm, change} from "redux-form";
import {StyleSheet, View, Text } from "react-native";
import {MetricToImperialConverter, MassUnit, FoodPreference} from "fitbeat.models";
import {
    RadioButtonWithTitle
} from "fitbeat.react-native-components";
import { HeightField, WeightField } from "../ui";
import { genders, unitPreferences, foodPreferences } from "../utils";
import {
    isNameValid,
    isPhoneNumberValid,
} from "../utils/validator";
import { focusOnInput } from "../utils/FocusOnInput";
import { UserDataConsumer, formatMobileNumber } from '../utils';
import CountryCodePicker from '../payments/components/CountryCodePicker';
import Theme from '../theme';
class PersonalInfoScreen extends Component {

    constructor(props) {
        super(props);
        const { t } = props;

        this.state = {
            message: null,
            isUnderage: false,
            genders,
            selectedGender: null,
            useImperial: false,
            genderSelectError: null,
            foodPref: FoodPreference.AllFoodGroups,
        };
    }

    componentDidUpdate = async (prevProps) => {
        if (JSON.stringify(prevProps.initialValues) !== JSON.stringify(this.props.initialValues)) {
            await this.initializeForm();
        }
    }

    componentDidMount = async () => {
        await this.initializeForm();
    };

    initializeForm = async () => {
        const userProfileToInitialize = { ...this.props.user.userProfile };
        const mobileNumber = userProfileToInitialize.mobileNumber === ' '
            ? ''
            : this.separateMobileNumber(userProfileToInitialize.mobileNumber);
        const { initialValues, initialize } = this.props;
        initialValues.mobileNumber = mobileNumber
        initialize(initialValues);
        this.setGender(initialValues.gender);
    }

    setGender = (gender) => {
        this.setState({ selectedGender: gender });
    }
    setImperial = (useImperial) => {
        this.setState({useImperial});
        this.props.updateField('height', '');
        this.props.updateField('weight', '');
    }

    setFoodPref = (foodPref) => {
        this.setState({foodPref});
    }

    formatAndSubmitValues = (customSubmit) => () => {
        const excludeHeightImperial = ({ heightImperial, ...rest }) => rest;
        this.props.handleSubmit(values => {
            if (!this.state.selectedGender) {
                this.setState({ genderSelectError: true });
                return;
            }
            this.setState({ genderSelectError: false });
            const copiedValues = excludeHeightImperial(values);
            copiedValues.gender = this.state.selectedGender;
            copiedValues.useImperialUnit = false;
            copiedValues.weight = parseFloat(copiedValues.weight);
            copiedValues.mealPreferences = {
                foodPreference: this.state.foodPref,
            };
            if (this.state.useImperial) {
                const parsedHeightObj = JSON.parse(values.heightImperial);
                copiedValues.height= MetricToImperialConverter.convertInchesAndFeetToCentimeters(parsedHeightObj)
                copiedValues.weight = MetricToImperialConverter.convertAmount(
                 MassUnit.Pound, MassUnit.Killogram, copiedValues.weight);
                copiedValues.useImperialUnit = true;
              }
            const countryCode = this.state.countryCode ?
            this.state.countryCode : this.state.phone.state.formattedNumber;
            copiedValues.mobileNumber = formatMobileNumber(countryCode, values.mobileNumber);
            customSubmit(copiedValues);
        })();
    }

    setCountryCode = (countryCode) => {
        const cc = countryCode && countryCode.value !== undefined ? countryCode.value : this.getDialCode();
        this.setState({ countryCode: cc })
    }

    separateMobileNumber = mobileNumber => {
        if (mobileNumber) {
            const phoneNumber = mobileNumber.slice(-9);
            return phoneNumber;
        }
        return "";
    };

    getDialCode = () => {
        const mobileNumber = this.props.user.userProfile.mobileNumber;
        if (mobileNumber && mobileNumber !== ' ') {
            const lengthOfNumber = mobileNumber.length;
            const dialCodeLength = lengthOfNumber - 9;
            const dialCode = mobileNumber.slice(0, dialCodeLength);
            return dialCode;
        }
        return '+61'
    }

    setPhone = (phone) => {
        this.setState({ phone: phone })
    }

    render() {
        const {
            t,
            textInputComponent,
            user: {
                userProfile,
            },
        } = this.props;
        const {
            genders,
            message,
            isUnderage,
            useImperial,
            selectedGender,
            genderSelectError
        } = this.state;
        return (
            <>
                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t('yourName')}</Text>
                    <Field
                        trim
                        forwardRef
                        showLabel={true}
                        name="firstname"
                        placeholder={t("formFields:firstname")}
                        component={textInputComponent}
                        returnKeyType="next"
                        autoCapitalize="words"
                        validate={isNameValid}
                        onSubmitEditing={() => focusOnInput(this.firstnameInput)}
                        ref={ref => {
                            this.firstnameInput = ref;
                        }}
                    />

                    <Field
                        trim
                        forwardRef
                        showLabel={true}
                        name="lastname"
                        placeholder={t("formFields:lastname")}
                        component={textInputComponent}
                        returnKeyType="next"
                        autoCapitalize="words"
                        validate={isNameValid}
                        onSubmitEditing={() => focusOnInput(this.lastnameInput)}
                        ref={ref => {
                            this.lastnameInput = ref;
                        }}
                    />
                </View>

                <View style={styling.horizontalSeparator} />

                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("chooseNickname")}</Text>
                    <Field
                        trim
                        forwardRef
                        showLabel={true}
                        name="nickname"
                        placeholder={t("formFields:nickname")}
                        component={textInputComponent}
                        returnKeyType="next"
                        autoCapitalize="words"
                        validate={isNameValid}
                        onSubmitEditing={() => focusOnInput(this.nicknameInput)}
                        ref={ref => {
                            this.nicknameInput = ref;
                        }}
                    />
                    <Text style={styling.sectionDescription}>{t("displayOnWorkout")}</Text>
                </View>

                <View style={styling.horizontalSeparator} />

                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("mobileNumber")}</Text>
                    <View style={styling.phoneNumberContainer}>
                        <CountryCodePicker userProfile={userProfile}
                            customControlStyle={{ backgroundColor: Theme.GREY_LIGHT}}
                            customOptionStyle={{ backgroundColor: Theme.GREY_LIGHT, color: Theme.GREY_MEDIUM }}
                            setCountryCode={this.setCountryCode} setPhone={this.setPhone} />
                        <View style={styling.mobileNumberContainerWeb}>
                            <Field
                                forwardRef
                                name="mobileNumber"
                                component={textInputComponent}
                                autoCapitalize="none"
                                placeholder={t("formFields:mobileNumber")}
                                keyboardType="numeric"
                                returnKeyType="done"
                                isRequired={true}
                                validate={[isPhoneNumberValid]}
                                ref={ref => {
                                    this.mobileNumberInput = ref;
                                }}
                                textInputStyle={{ width: '100%' }}
                                showLabel={false}
                            />
                        </View>
                    </View>
                    <Text style={styling.sectionDescription}>{t("whyMobileNumberIsNeeded")}</Text>
                </View>

                <View style={styling.horizontalSeparator} />

             <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("selectFoodPreference")}</Text>
                    <View>
                    {foodPreferences.map(foodPref => {
                            return (<View style={{paddingVertical:5}}>
                                <RadioButtonWithTitle
                                    isActive={foodPref.value === this.state.foodPref}
                                    title={foodPref.display}
                                    textStyle={[Theme.textStyle.bodyCopyReg, { color : Theme.CHARCOAL}]}
                                    overrideRadioButtonStyles={{
                                        inactiveStyle: {
                                            backgroundColor: Theme.GREY_LIGHT,
                                        },
                                        innerInactiveStyle: {
                                            backgroundColor: Theme.GREY_LIGHT,
                                        },
                                        innerActiveStyle: {
                                            backgroundColor: Theme.WHITE,
                                        }
                                    }}
                                    onPress={() => {this.setFoodPref(foodPref.value); }}
                                /></View>);
                        })}
                    </View>
             </View>
                <View style={styling.horizontalSeparator} />
                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("selectUnitPreference")}</Text>
                    <View>
                    {unitPreferences.map(unitPrefItem => {
                            return (<View style={{paddingVertical:5}}>
                                <RadioButtonWithTitle
                                    isActive={unitPrefItem.useImperialUnit === useImperial}
                                    title={unitPrefItem.display}
                                    textStyle={[Theme.textStyle.bodyCopyReg, { color : Theme.CHARCOAL}]}
                                    overrideRadioButtonStyles={{
                                        inactiveStyle: {
                                            backgroundColor: Theme.GREY_LIGHT,
                                        },
                                        innerInactiveStyle: {
                                            backgroundColor: Theme.GREY_LIGHT,
                                        },
                                        innerActiveStyle: {
                                            backgroundColor: Theme.WHITE,
                                        }
                                    }}
                                    onPress={() => {this.setImperial(unitPrefItem.useImperialUnit)}}
                                /></View>)
                        })}
                    </View>
             </View>
             <View style={styling.horizontalSeparator} />
                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("howTallAreYou")}</Text>
                    <HeightField useImperialUnit={useImperial}/>
                    <Text style={styling.sectionDescription}>{t("requiredForCalStat")}</Text>
                </View>
                <View style={styling.horizontalSeparator} />
                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("weightInputLabel")}</Text>
                    <WeightField useImperialUnit={useImperial} />
                    <Text style={styling.sectionDescription}>{t("weightDescription")}</Text>
                </View>

                <View style={styling.horizontalSeparator} />

                <View style={styling.inputSection}>
                    <Text style={styling.subHeading}>{t("selectGender")}</Text>
                    <View style={{ flexDirection: 'row', paddingVertical: 10 }}>
                        {genders.map(singleGender => {
                            return (<View style={{ width: '30%' }}>
                                <RadioButtonWithTitle
                                  isActive={selectedGender && singleGender.value === selectedGender}
                                  title={singleGender.display}
                                  textStyle={[Theme.textStyle.bodyCopyReg, { color : Theme.CHARCOAL}]}
                                  overrideRadioButtonStyles={{
                                      inactiveStyle: {
                                          backgroundColor: Theme.GREY_LIGHT,
                                      },
                                      innerInactiveStyle: {
                                          backgroundColor: Theme.GREY_LIGHT,
                                      },
                                      innerActiveStyle: {
                                          backgroundColor: Theme.WHITE,
                                      }
                                  }}
                                  onPress={() => { this.setGender(singleGender.value) }}
                                /></View>)
                        })}
                    </View>
                    <Text style={[styling.sectionDescription, { color: genderSelectError ? Theme.RED : Theme.CHARCOAL }]}>{t("requiredForCalStat")}</Text>
                </View>
                <>
                    {this.props.render({
                        message,
                        handleSubmit: this.formatAndSubmitValues,
                        isUnderage
                    })}
                </>
            </>
        );
    }
}

const styling = StyleSheet.create({
    subHeading: {
        ...Theme.textStyle.bodyCopyBold,
    },
    sectionDescription: {
      ...Theme.textStyle.bodyCopyReg,
      color: Theme.CHARCOAL,
    },
    inputSection: {
        padding: 10,
        paddingVertical: 15,
    },
    horizontalSeparator: {
        borderBottomWidth: 1,
        borderBottomColor: Theme.GREY_LIGHT,
        marginHorizontal: 10,
    },
    phoneNumberContainer: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    mobileNumberContainerWeb: {
        flex: 1,
    },
});

PersonalInfoScreen = translate(["auth", "formFields"], { wait: true })(
    PersonalInfoScreen
);
const mapDispatchToProps = (dispatch) => {
    return {
      updateField: (field, data) => dispatch(change( 'AgeRestrictionForm', field, data )),
    };
  };

PersonalInfoScreen = reduxForm({
    form: "AgeRestrictionForm",
    enableReinitialize: true
})(PersonalInfoScreen);
export default UserDataConsumer(connect(undefined, mapDispatchToProps)(PersonalInfoScreen));
